module.exports = __webpack_public_path__ + "img/arrow_next_page.129ff6c1.svg";